<template>
  <div>
    <h3 class="page-heading">Update Project</h3>
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "update_story_wrapper",
  beforeMount() {
    if (this.$route.path === "/newprofile/update-story") {
      this.$router.push("/newprofile/update-story/step-1");
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/v2/update_story/update_story_wrapper.vue